import React from 'react';

export default function Nose() {
	return (
		<g>
			<path className="fill penguin--beak" d="M254.1199036,154.3847809c-3.2996826,0-10.0014038,8.9412842-10.0014038,10.495163l9.9182434,1.9044342
				l10.0838013-1.9044342C264.1205444,163.144165,257.4195862,154.3847809,254.1199036,154.3847809z" />
			<path className="fill fill--dark penguin--beak" d="M254.0367432,166.7843781l-9.9182434-1.9044342c0,1.554184,3.8116302,5.4132996,3.8116302,5.4132996
				c3.4180756,3.4185333,8.9602509,3.4185333,12.3785553,0c0,0,3.8118591-3.6772003,3.8118591-5.4132996L254.0367432,166.7843781z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/TuxedoBird/Nose.js